<div class="header-modal mb-0">
  <div class="main-title w-100 mt-0 mb-0">
    <h3>{{data.fullName ? data.fullName : ('Delete ' + data.name)}}</h3>
  </div>

  <span class="close-dialog" (click)="noDelete()">
      <i class="material-icons">close</i>
  </span>
</div>

<div mat-dialog-content>
  <p class="payment-title">{{data.name}}</p>
</div>
<form *ngIf="formGroup" [formGroup]="formGroup">
  <div class="refund-sections">
    <div formArrayName="invoices">
      <div *ngFor="let item of refundInvoices; let i = index;" class="invoice-item">
        <div class="invoice-list" [formGroupName]="i">
          <span class="invoice-name">Invoice: {{item.number}}</span>
          <div class="product-item input-wrap mr-10">
            <input class="bank-reference" type="text" [disabled]="true" [value]="item.refundAmount">
          </div>
          <div class="product-item input-wrap mr-10">
            <input appInputTrimmer class="bank-reference" (input)="onChangePrice($event)" formControlName="amount"
                   type="number" placeholder="Amount">
            <span *ngIf="formGroup.get('invoices').controls[i].get('amount').invalid &&
                              (formGroup.get('invoices').controls[i].get('amount').dirty || formGroup.get('invoices').controls[i].get('amount').touched)"
                  class="error-message">
                        <span
                          *ngIf="formGroup.get('invoices').controls[i].get('amount').errors.pattern">
                           Please enter a valid amount value
                        </span>
                      </span>
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-line">
    </div>
    <div class="description-total">
      <label for="description">Description <span class="required-symbol">*</span></label>
      <app-char-counter-textarea
        class="payment-description"
        id="description"
        [textValue]="this.charChange"
        [maxNumberOfCharacters]="1000"
        ngDefaultControl
        placeholderText="Description"
        [formControl]="formGroup.get('description')"
        (valueChange)="onTextareaValueChanged($event)">
      </app-char-counter-textarea>

      <div class="payment-invoices-total">
        <p class="horizontal-dotted-line">Refundable Amount:<span class="dotted-line"></span></p>
        <span
          class="payment-amount">{{maxAmount || 0 | number:'1.2-2'}}{{currencySymbolAfter}}
                </span>
      </div>
      <div class="payment-invoices-total">
        <p class="horizontal-dotted-line">Amount To Be Refunded:<span class="dotted-line"></span></p>
        <span
          class="payment-amount">{{amount || 0 | number:'1.2-2'}}{{currencySymbolAfter}}
                </span>
      </div>
    </div>
  </div>
</form>
<div class="footer-modal footer-modal--center mt-20">
  <cmp-button [class]="'cancel mr-20'" text="Cancel" (click)="noDelete()"></cmp-button>
  <cmp-button [class]="(data?.type || 'Delete')  === 'Delete' ? 'danger' : 'primary'" (click)="delete()"
              [text]="data?.type || 'Delete'"></cmp-button>
</div>
